import React from "react";
import parse from "html-react-parser";
import PropTypes from "prop-types";

import { Image, LogEvent } from "@learningblocks/shared-components";

import styles from "./style.module.scss";
import { SolutionTube } from "@learningblocks/storybook-components/lib/ProtocolComponents/SolutionTube";
import { GlossaryProvider } from "@learningblocks/storybook-components/lib/GlossaryProvider";

import { PlainText } from "../PlainText";

import { FormattedMessage } from "react-intl";

export function MaterialCard(props) {
  const [open, setOpen] = React.useState(null);
  const { onOpenGlossary } = React.useContext(GlossaryProvider.Context);

  const toggleSlide = () => {
    setOpen((slideOpen) => !slideOpen);
  };

  const renderImage = () => {
    let ariaLabel = props.ariaLabel ? props.ariaLabel : props.fullName;
    if (props.isSolutionTube) {
      return (
        <div className={styles.materialcard__imageBlock}>
          <SolutionTube
            title={ariaLabel}
            isOpen={false}
            id={props.id}
            size={props.solutionTube.size}
            type={props.solutionTube.type}
            toggleOpen={() => {}}
            solution={{
              solutionColor: props.solutionTube.solutionColor,
              circleColor: props.solutionTube.circleColor,
              circleOutline: props.solutionTube.circleOutline,
              isOpen: false,
              label: props.solutionTube.label,
            }}
          />
        </div>
      );
    }
    if (props.imageComponent) {
      return (
        <div className={styles.materialcard__imageBlock}>
          {props.imageComponent}
        </div>
      );
    } else {
      return (
        <div
          id={"materialcard__image" + props.fullName}
          style={{
            backgroundColor: "#003e6b",
            margin: "auto",
            padding: "auto",
          }}
        >
          <Image
            style={{ ...props.imageStyle }}
            src={props.image}
            alt={props.fullName}
            className={styles.materialcard__image}
          />
        </div>
      );
    }
  };

  const renderGlossaryLink = () => {
    if (props.contentID) {
      return (
        <LogEvent
          logEventProps={{
            event_type: "sim_material_term_read_more clicked",
            event_schema: "term",
            term: fullName.replace(/<[^>]+>/g, ""),
            glossary_id: props.contentID,
          }}
          actionProps={{ onClick: { action: "click" } }}
          elementType="button"
        >
          <div
            style={{ lineHeight: 1.5, color: "#fff" }}
            onClick={(e) => {
              e.stopPropagation();
              onOpenGlossary(props.contentID);
            }}
          >
            <p>Read more</p>
          </div>
        </LogEvent>
      );
    }
  };

  const { fullName, description, glossaryTitle } = props;

  return (
    <div className={styles.materialcard} dir="auto">
      <LogEvent
        logEventProps={{
          event_type: "sim_material_term viewed",
          event_schema: "term",
          term: fullName.replace(/<[^>]+>/g, ""),
          glossary_id: props.contentID,
        }}
        actionProps={{ onClick: { action: "click" } }}
        elementType="button"
      >
        <button className={styles.materialcard__button} onClick={toggleSlide}>
          <div
            aria-hidden={open ? "true" : "false"}
            aria-live="polite"
            aria-atomic="true"
          >
            {renderImage()}
          </div>
          <div className={styles.materialcard__titleblock} aria-hidden="true">
            <p className={styles.materialcard__titleblock_text}>
              <FormattedMessage
                id={parse(fullName)}
                defaultMessage={parse(fullName)}
              />
            </p>
          </div>
        </button>
      </LogEvent>
      <div
        className={`${styles.materialcard__slideblock} ${
          open !== null ? (open ? styles.open : styles.closed) : ""
        }`}
        onClick={toggleSlide}
        aria-hidden={open ? "false" : "true"}
        aria-live="polite"
        aria-atomic="true"
      >
        <p className={styles.materialcard__slideblock_title} aria-hidden="true">
          <FormattedMessage
            id={parse(fullName)}
            defaultMessage={parse(fullName)}
          />
        </p>
        <p className={styles.materialcard__slideblock_text}>
          <PlainText text={description} />
        </p>
        {renderGlossaryLink()}
      </div>
    </div>
  );
}

MaterialCard.propTypes = {
  /**
   * Url for image to be displayed on widget
   */
  image: PropTypes.string,
  /**
   * Title for the widget
   */
  title: PropTypes.string,
  /**
   * description for the widget
   */
  description: PropTypes.string,
  /**
   * React component to display instead of image [ Overrided image prop]
   */
  imageComponent: PropTypes.element || null,

  hassolutionTube: PropTypes.bool,

  solutionTube: PropTypes.any,
};

MaterialCard.defaultProps = {
  imageComponent: null,
};
